import { cn } from 'lib/utils';
import { Image } from './styles';
import { useMemo } from 'react';
import AmazonLogo from 'assets/images/amazon-logo.jpg';
import ShopifyLogo from 'assets/images/shopify-logo.webp';
import { Typography } from 'components/ui/typography';
import { Product } from '../../../../app/graphql/generated/cart/graphql';

type Props = {
  product: Product | undefined;
  marketplace: 'amazon' | 'shopify';
  aspectRatio?: 'portrait' | 'square';
  width?: number | string;
  height?: number | string;
  className?: string;
  variantId?: string;
};

export function ProductCard({ product, className, width, height, marketplace, variantId }: Props) {
  const productUrl = useMemo(() => {
    if (product && 'storeCanonicalURL' in product) {
      return `${product.storeCanonicalURL}${product.url}`;
    }
    return product?.url;
  }, [product]);

  let logo = ShopifyLogo;
  if (marketplace === 'amazon') {
    logo = AmazonLogo;
  }

  return (
    <div className={cn('space-y-3', className)}>
      <div className="w-full overflow-hidden rounded-md">
        <Image
          src={product?.images?.[0]?.url?.toString() ?? logo}
          alt={product?.title}
          width={width}
          height={height}
          className={cn('h-auto object-cover transition-all hover:scale-105', 'aspect-[3/4]')}
        />
      </div>
      <div className="space-y-1">
        <Typography
          variant="h4"
          as="h3"
          className="line-clamp-2 text-ellipsis whitespace-normal leading-none"
        >
          {product?.title}{' '}
          {variantId && (
            <Typography variant="small" as="span">
              ({variantId})
            </Typography>
          )}
        </Typography>
        <Typography variant="small" asChild>
          <a href={productUrl} target="_blank" className="line-clamp-1 whitespace-normal">
            {productUrl}
          </a>
        </Typography>
      </div>
    </div>
  );
}
